module.exports = __webpack_public_path__ + "static/whatcar-852ec9c3cdd33068354a2c86f0c357f2.jpg";